import colors from 'constants/colors';
import styled from 'styled-components';

export const LegendContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  box-sizing: border-box; 
  margin-right: 15px;

  .legendTitle {
    font-size: 14px;
    font-weight: 600;
    color: ${colors.white};
  }
`;

export const LegendItemContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 10px;

  .iconContainer {
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    background-color: ${(props) => props.backgroundColor ? props.backgroundColor : colors.white};
  }

  .iconLayout {
    width: 20px;
    height: 20px;
  }

  .legendLabel {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.silver};
    white-space: nowrap;
  }

  @media only screen and (max-width: 1200px) {
    flex-basis: 25%;
    height: 100px;

    .iconContainer {
      margin-bottom: 5px;  
    }
  }

  @media only screen and (max-width: 767px) {

    height: 90px;
    
    .iconContainer {
      width: 30px;
      height: 30px;
    }

    .iconLayout {
      width: 15px;
      height: 15px;
    }

    span{
      font-size: 12px;
    }
  }
`;
